import emailjs from '@emailjs/browser';
import type { OrderFormValues, ServiceModel, ServiceTier } from '../types/portfolio';

const emailConfig = {
  serviceId: import.meta.env.VITE_EMAILJS_SERVICE_ID,
  templateId: import.meta.env.VITE_EMAILJS_TEMPLATE_ID,
  publicKey: import.meta.env.VITE_EMAILJS_PUBLIC_KEY,
};

function list(items: string[]) {
  return items.length ? items.map((item) => `- ${item}`).join('\n') : '- None';
}

export function buildOrderEmailMessage(
  orderId: string,
  values: OrderFormValues,
  files: File[],
  tier: ServiceTier,
  model: ServiceModel,
) {
  return [
    'NEW ORDER - AWAITING PAYMENT',
    '',
    'STATUS',
    'Payment status: awaiting manual Stripe verification',
    `Order ID: ${orderId}`,
    '',
    'CLIENT',
    `Name: ${values.name}`,
    `Email: ${values.email}`,
    `Telegram / Discord: ${values.handle}`,
    '',
    'PROJECT',
    `Work type: ${tier.name}`,
    `Category: ${tier.name} / ${model.name}`,
    `Selected model: ${model.name}`,
    `Model price: ${model.price}`,
    `Budget field: ${values.budget}`,
    `Deadline: ${values.deadline}`,
    `Priority: ${values.priority}`,
    '',
    'FEATURES',
    list(values.features),
    '',
    'MODEL INCLUDES',
    list(model.features),
    '',
    'FILES',
    list(files.map((file) => file.name)),
    '',
    'DESCRIPTION',
    values.description,
    '',
    'NEXT STEP',
    'Open Stripe Dashboard and verify payment by this Order ID or customer email.',
  ].join('\n');
}

export async function sendAwaitingPaymentEmail(
  orderId: string,
  values: OrderFormValues,
  files: File[],
  tier: ServiceTier,
  model: ServiceModel,
) {
  if (!emailConfig.serviceId || !emailConfig.templateId || !emailConfig.publicKey) {
    return false;
  }

  const message = buildOrderEmailMessage(orderId, values, files, tier, model);

  await emailjs.send(
    emailConfig.serviceId,
    emailConfig.templateId,
    {
      subject: `New order awaiting payment - ${orderId}`,
      order_id: orderId,
      payment_status: 'awaiting_payment',
      from_name: values.name,
      from_email: values.email,
      contact: values.handle,
      work_type: tier.name,
      category: `${tier.name} / ${model.name}`,
      selected_model: model.name,
      selected_price: model.price,
      budget: values.budget,
      deadline: values.deadline,
      priority: values.priority,
      features: values.features.join(', '),
      files: files.map((file) => file.name).join(', '),
      description: values.description,
      message,
      structured_message: message,
    },
    { publicKey: emailConfig.publicKey },
  );

  return true;
}
